import TagManager from 'react-gtm-module';

// Venue-search VS1.2. No names, emails or user IDs (DATA-STRATEGY.md Pillar 7).
const push = (dataLayer) => TagManager.dataLayer({ dataLayer });

export const tagRequirementsView = (version) => push({ event: 'host_requirements_view', requirementsVersion: version });

export const tagRequirementsYes = (version) => push({ event: 'host_requirements_yes', requirementsVersion: version });

// statementIds: the stable IDs answered "No", e.g. "vendors,rightToList".
export const tagRequirementsNo = (version, statementIds) =>
  push({ event: 'host_requirements_no', requirementsVersion: version, statementIds: statementIds.join(',') });
